import { render, staticRenderFns } from "./District.vue?vue&type=template&id=3bba0ed2&scoped=true"
import script from "./District.vue?vue&type=script&lang=js"
export * from "./District.vue?vue&type=script&lang=js"
import style0 from "./District.vue?vue&type=style&index=0&id=3bba0ed2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bba0ed2",
  null
  
)

export default component.exports